/**
 * Where the customer-facing resolution of a service-desk ticket stands (PAUL-3739). Derived by the backend from the
 * dates the ticket records, integers on the wire. The company only ever sees None or Published: a draft waiting for
 * approval and whether the text was emailed are Pauly's business, so they read as None and Published there.
 */
export enum ServiceDeskResolutionStatus {
  None = 0,
  AwaitingApproval = 1,
  Published = 2,
  Emailed = 3,
}

export const ServiceDeskResolutionStatusTranslations: Record<ServiceDeskResolutionStatus, string> = {
  [ServiceDeskResolutionStatus.None]: 'service_desk.resolution_status.none',
  [ServiceDeskResolutionStatus.AwaitingApproval]: 'service_desk.resolution_status.awaiting_approval',
  [ServiceDeskResolutionStatus.Published]: 'service_desk.resolution_status.published',
  [ServiceDeskResolutionStatus.Emailed]: 'service_desk.resolution_status.emailed',
};

/** `lib-select` options ({ key, value }), in the order a resolution moves through them. */
export const ServiceDeskResolutionStatusOptions = [
  ServiceDeskResolutionStatus.None,
  ServiceDeskResolutionStatus.AwaitingApproval,
  ServiceDeskResolutionStatus.Published,
  ServiceDeskResolutionStatus.Emailed,
].map((status) => ({ key: ServiceDeskResolutionStatusTranslations[status], value: status }));
